<template>
  <div id="container">
    <div id="wrap">
      <div id="startMenu">
        <h1>Pong</h1>
        <button id="startBtn">Start</button>
      </div>
      <div id="pauseMenu">
        <h1>Pause</h1>
        <button id="continueBtn">Continue</button>
        <button id="restartBtn">Restart</button>
      </div>
      <div id="gameOverMenu">
        <h1 id="gameMessage"></h1>
        <button id="againBtn">Try again</button>
      </div>
      <div id="gameplay">
        <canvas id="gameCanvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../helpers/api/request";

export default {
  name: "Pong",

  data() {}
};
</script>

<style scoped>
#container {
  position: absolute;
  width: 50%;
  height: 50%;
  min-height: 400px;
  top: 130px;
  bottom: 0;
  border: solid;
  left: 30%;
}
#wrap {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #1c2529;
}
#wrap > div {
  position: fixed;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: 0.5s;
  filter: blur(20px);
  transform: scale(0.5);
}

#wrap > div.active {
  opacity: 1;
  pointer-events: auto;
  z-index: 1;
  filter: blur(0);
  transform: scale(1);
}

#wrap > #gameplay {
  opacity: 1;
  z-index: 0;
  transform: scale(1);
  filter: blur(0);
}

#wrap > #gameplay > #gameCanvas {
  width: 400;
  height: 400;
}
#wrap > div.active ~ #gameplay {
  opacity: 0.75;
  filter: blur(10px);
  transform: scale(0.95);
}

button {
  background-color: white;
  border: 0;
  border-radius: 200px;
  padding: 16px 24px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1.25px;
  font-size: 16px;
  margin: 16px;
  min-width: 160px;
  outline: none;
  transition: 0.25s;
  opacity: 0.75;
  cursor: pointer;
}

button:hover {
  opacity: 1;
}

h1 {
  color: white;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 48px;
  margin-top: 0;
}
</style>
